import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { WorkflowStats } from "./components/WorkflowStats";
import { WorkflowInsuranceTypes } from "./components/WorkflowInsuranceTypes";
import { WorkflowPricing } from "./components/WorkflowPricing";
import { WorkflowUpdate } from "./components/WorkflowUpdate";

interface WorkflowCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  index: number;
  stats?: {
    label: string;
    value: string;
  };
  insuranceTypes?: Array<{
    name: string;
    icon: LucideIcon;
  }>;
  pricing?: {
    premium: string;
    coverage: string;
    periods: string[];
  };
  update?: string;
}

export const WorkflowCard = ({
  icon: Icon,
  title,
  description,
  index,
  stats,
  insuranceTypes,
  pricing,
  update
}: WorkflowCardProps) => {
  return (
    <Card
      className="p-4 sm:p-6 hover:shadow-lg transition-shadow duration-300 animate-fade-up opacity-100"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
        <Icon className="text-primary" size={20} />
      </div>
      
      <h3 className="text-lg sm:text-xl font-bold text-primary-dark mb-2">
        {title}
      </h3>
      
      <p className="text-neutral text-sm sm:text-base mb-4">
        {description}
      </p>

      {stats && <WorkflowStats {...stats} />}
      {insuranceTypes && <WorkflowInsuranceTypes types={insuranceTypes} />}
      {pricing && <WorkflowPricing {...pricing} />}
      {update && <WorkflowUpdate update={update} />}
    </Card>
  );
};